import _ from 'lodash';
import api from '../../api';

const defaultQuery = {
  order_by: 'created_at',
  dir: 'desc',

  property_type: null,
  available_from: null,
  occupants: null,
  bills_included: null,
  has_media: null,
  from_agent: null,
  amenities: null,
  facilities: null,
};

const state = {
  query: defaultQuery,
  instance: null,
  pagination: null,

  schema: null,

  // B
  fetching: false,
  fetched: false,
  // R
  instance_loading: false,
  instance_loaded: false,
  // E-A
  instance_saving: false,
  instance_saved: false,
  // D
  instance_deleting: false,
  instance_deleted: false,
};

const actions = {
  setQuery: function(context, params) {
    context.commit('handleSetQuery', params);
  },

  setQueryParam: function(context, payload) {
    context.commit('handleSetQueryParam', payload);
  },

  resetQuery: function(context, params) {
    context.commit('handleSetQuery', defaultQuery);
  },

  fetch: function(context) {
    const query = context.state.query;
    const promise = api.search.my(query);
    context.commit('handleStatus', { fetching: true });
    promise
      .then((response) => {
        context.commit('handlePaginationResults', response.data);
        context.commit('handleStatus', { fetched: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { fetched: false });
      })
      .then(() => {
        context.commit('handleStatus', { fetching: false });
      });
  },

  create: function(context) {
    const instance_params = context.state.instance;
    const promise = api.search.create(instance_params);
    context.commit('handleStatus', { instance_loading: true });
    promise
      .then((response) => {
        context.commit('handleSchemaLoaded', response.data);
        context.commit('handleInititalizingInstanceFromSchema', response.data);
        context.commit('handleStatus', { instance_loaded: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_loaded: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_loading: false });
      });
  },

  edit: function(context, payload) {
    const uuid = payload;
    const instance_params = context.state.instance;
    const promise = api.search.edit(uuid, instance_params);
    context.commit('handleStatus', { instance_loading: true });
    promise
      .then((response) => {
        context.commit('handleSchemaLoaded', response.data);
        context.commit('handleInititalizingInstanceFromSchema', response.data);
        context.commit('handleStatus', { instance_loaded: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_loaded: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_loading: false });
      });
  },

  store: function(context, payload) {
    const uuid = payload;
    const instance_params = context.state.instance;

    const promise = api.search.store(instance_params);
    context.commit('handleStatus', { instance_saving: true });
    return promise
      .then((response) => {
        context.commit('handleStatus', { instance_saved: true });
        context.commit('handleResetInstance', {});
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_saved: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_saving: false });
      });
  },

  update: function(context, payload) {
    const uuid = payload;
    const instance_params = context.state.instance;
    const promise = api.search.update(uuid, instance_params);
    context.commit('handleStatus', { instance_saving: true });
    return promise
      .then((response) => {
        context.commit('handleStatus', { instance_saved: true });
        context.commit('handleResetInstance', {});
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_saved: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_saving: false });
      });
  },

  subscribe: function(context, payload) {
    const uuid = payload;
    const promise = api.search.subscribe(uuid);
    context.commit('handleStatus', { instance_saving: true });
    return promise
      .then((response) => {
        context.commit('handleStatus', { instance_saved: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_saved: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_saving: false });
      });
  },

  delete: function(context, payload) {
    const uuid = payload;
    const promise = api.search.delete(uuid);
    context.commit('handleStatus', { instance_deleting: true });
    return promise
      .then((response) => {
        context.commit('handleStatus', { instance_deleted: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_deleted: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_deleting: false });
      });
  },

  unsubscribe: function(context, payload) {
    const uuid = payload;
    const promise = api.search.unsubscribe(uuid);
    context.commit('handleStatus', { instance_saving: true });
    return promise
      .then((response) => {
        context.commit('handleStatus', { instance_saved: true });
      })
      .catch((error) => {
        context.commit('handleStatus', { instance_saved: false });
      })
      .then(() => {
        context.commit('handleStatus', { instance_saving: false });
      });
  },

  updateInstance: function(context, payload) {
    context.commit('handleUpdateInstance', payload);
  },

  resetInstance: function(context, payload) {
    context.commit('handleResetInstance', null);
  },
};

const mutations = {
  handleSetQuery: function(state, data) {
    _.set(state, 'query', data);
  },

  handleSetQueryParam: function(state, payload) {
    _.each(payload, (value, key) => {
      if (value != null) {
        _.set(state.query, key, value);
      } else {
        _.unset(state.query, key);
      }
    });
    state.query = Object.assign({}, state.query);
  },

  handleLoadingStatus: function(state, { action, status }) {
    _.set(state, `progress.${action}`, status);
  },

  handleShow: function(state, data) {
    _.set(state, `item`, data);
  },

  handlePaginationResults: function(state, data) {
    _.set(state, `pagination`, data);
  },

  handleSchemaLoaded: function(state, data) {
    _.set(state, `schema`, data);
  },

  handleCancel: function(state) {
    _.set(state, `item`, null);

    // Route go to current index page (back)
    // router.push({
    //         name:'crud.index',
    //         params: {
    //           target: target
    //         }
    //       });
  },

  handleEdit: function(state, data) {
    _.set(state, `item`, {});
    _.set(state, `item`, data);

    _.each(data, (config, k) => {
      let key = config.id;
      let default_value = _.get(config, 'default', null);
      let current_value = _.get(config, 'value', default_value);
      current_value = current_value != null ? current_value : default_value;
      _.set(state, `instance.${key}`, current_value);
    });
  },

  handleUpdateInstance: function(state, payload) {
    _.each(payload, (value, key) => {
      if (value == null) {
        _.unset(state, `instance.${key}`);
      } else {
        _.set(state, `instance.${key}`, value);
      }
    });
    state.instance = Object.assign({}, state.instance);

    // Sync with schema
    let schema = Object.assign({}, state.schema);
    _.each(payload, (value, key) => {
      if (_.has(schema, key)) {
        _.set(schema, `${key}.value`, value);
      }
    });
    state.schema = schema;
  },

  handleResetInstance: function(state, payload) {
    _.set(state, 'instance', {});
  },

  handleStatus: function(state, payload) {
    _.each(payload, (value, key) => {
      _.set(state, key, value);
    });
  },

  handleInititalizingInstanceFromSchema: function(state, payload) {
    let new_insance = {};
    _.each(payload, (config, k) => {
      let key = config.id;
      let default_value = _.get(config, 'default', null);
      let current_value = _.get(config, 'value', default_value);
      current_value = current_value != null ? current_value : default_value;
      _.set(new_insance, key, current_value);
    });
    state.instance = new_insance;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
